import { isArray } from 'es-toolkit/compat'
import { defineStore } from 'pinia'

export enum NotificationType {
  Success = 'success',
  Error = 'error'
}

// State
type Notification = {
  type: NotificationType
  message: string[]
  topPosition: number
}
type State = Notification

const showPosition = 40
const hidePosition = -100
const durationForAutoClose = 7000

export const useNotificationStore = defineStore('notification', {
  state: (): State => {
    return {
      topPosition: hidePosition,
      type: NotificationType.Success,
      message: []
    }
  },
  actions: {
    showNotification(
      message: string | string[],
      type: NotificationType = NotificationType.Success,
      autoClose = true
    ) {
      // メッセージをセット
      if (isArray(message)) {
        this.$patch({
          message,
          type
        })
      } else {
        this.$patch({
          message: [message],
          type
        })
      }
      // 表示アニメーション（CSS transitionで制御）
      this.topPosition = showPosition
      if (autoClose) {
        setTimeout(() => {
          this.hideNotification()
        }, durationForAutoClose)
      }
    },
    hideNotification() {
      // 非表示アニメーション（CSS transitionで制御）
      this.topPosition = hidePosition
    }
  }
})
